export default [
  {
    title: 'breadcrumb.company',
    route: 'list-company',
    icon: '',
    resource: 'company',
    action: 'read'
  }
];